import React from 'react'
import PhoneInputWithCountrySelect from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import './PhoneInput.scss'
import styles from './PhoneInput.module.scss'
export interface PhoneInputProps {
     value: string | undefined
    onChange: (value:  string | undefined) => void,
    label?: string
    error?: boolean
}

export default function PhoneInput({value, onChange, label = "Téléphone", error}: PhoneInputProps) {
  return (
    <div className={[styles['input'], error ? styles['input--error']: ""].join(" ")}>
        <label className={[styles['input__label'], error ? styles['input__label--error']: ""].join(" ")}>{label}</label>
         <PhoneInputWithCountrySelect
            style={{border: "transparent", width: "100%", height: "100%"}}
            value={value}
            defaultCountry="BJ"
        countries={['BJ', 'FR', 'TG', 'SN', 'BF']}
        
            onChange={(value: any) => onChange(value)} />
    </div>
  )
}
